export default "__VITE_ASSET__DVWpyNru__"